export function getLangType() {
  return localStorage.getItem("lang") || "en";
}
export function getValueByLang(obj: any) {
  let result;
  let lang = getLangType();
  if (obj && lang) {
    result = obj[lang] ? obj[lang] : obj;
  }
  return result;
}
